export function buildQueryString(request: Record<string, any>, baseUrl: string = '', locale?: string): string {
    const params = new URLSearchParams();

    if (locale) {
        request = { ...request, locale: locale };
    }
    if (!request) return baseUrl;

    Object.entries(request).forEach(([key, value]) => {
        if (value == null) return;
        if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, item));
        } else if (value.toString().trim() !== '') {
            params.append(key, value.toString());
        }
    });

    const queryString = params.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

export function mergeParamsToUrl(
    path: string,
    newParams: Record<string, any>,
    additionalParams?: Record<string, any>,
    locale?: string
): string {
    const merged: Record<string, any> = {};

    // A caller may hand us a path that already carries a query (e.g. `/extensions/skills?teachDraft=id`).
    // Fold those into the merge (lowest priority) instead of letting buildQueryString append a second `?`,
    // which would glue the added params onto the last existing value.
    const queryStart = path.indexOf('?');
    const basePath = queryStart >= 0 ? path.slice(0, queryStart) : path;
    if (queryStart >= 0) {
        const existing = new URLSearchParams(path.slice(queryStart + 1));
        for (const key of new Set(existing.keys())) {
            const values = existing.getAll(key);
            merged[key] = values.length > 1 ? values : values[0];
        }
    }

    // Safely spread existing params (if any)
    Object.entries(additionalParams || {}).forEach(([key, value]) => {
        merged[key] = value;
    });

    // Override or add new ones
    Object.assign(merged, newParams);

    return buildQueryString(merged, basePath, locale);
}
